import type { HeroProps } from '@/components/lemonadeGoesGlobal/Hero';
import { sharedConfig } from '@/pageConfig/shared';
import og from '@/static/assets/lemonade_goes_global/og.png';
import { DocumentTypes } from 'contentlayer/generated';
import content from '../../../../.contentlayer/generated/LemonadeGoesGlobal/lemonadeGoesGlobal__en-NL.mdx.json';
import type { BasePageConfig } from '../../BasePageConfig';

export interface Config extends BasePageConfig {
  hero: HeroProps;
}

export const config: Config = {
  layout: { ...sharedConfig['en-NL'].layout, showAskUsAnything: true },
  seo: {
    title: "Where's Lemonade Available in the US and Europe? | Lemonade",
    metaTitle: "Where's Lemonade Available in the US and Europe? | Lemonade",
    description:
      'Lemonade is making moves, bringing renters and homeowners insurance powered by tech and driven by social good to the US and Europe ✨ Check here to see where Lemonade is available, or just enter your email and we ll drop you a line when we get there! GoLemonade',
    ogImage: og.src,
  },
  hero: {
    title: 'Be the First to Know!',
    subtitle: `We’re rolling out across the <a href="https://www.lemonade.com/blog/lemonade-expansion-united-states/">US</a> and Europe.\nLeave your email and we’ll let you know when we’re headed your way`,
  },
  MDXContent: content as DocumentTypes,
};
